import React, { useState } from "react";
import axios from "axios";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    TextField,
    Box,
} from "@mui/material";

const AddFlowerModal = () => {
    const [open, setOpen] = useState(false);
    const [productData, setProductData] = useState({
        item_name: "",
    });

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setProductData({
            item_name: "",
            price: "",
            item_type: "",
            itemImages: [],
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setProductData({
            ...productData,
            [name]: value,
        });
    };

    const handleSave = (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append("flowerName", productData.item_name);

        axios
            .post("https://tsetsegtuw.templateapi.xyz/flower/", formData)
            .then((response) => {
                console.log("Product saved successfully:", response.data);
                handleClose();
            })
            .catch((error) => {
                console.error("Error saving product:", error);
            });
    };

    return (
        <div>
            <Button variant="contained" color="primary" onClick={handleClickOpen}>
                Цэцэг нэмэх
            </Button>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Цэцэг нэмэх</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Цэцэгний нэр"
                        type="text"
                        name="item_name"
                        fullWidth
                        value={productData.item_name}
                        onChange={handleChange}
                    />

                    <TextField
                        margin="dense"
                        label="Үнэ "
                        type="number"
                        name="price"
                        fullWidth
                        value={productData.price}
                        onChange={handleChange}
                    />
                </DialogContent>
                <DialogActions>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            padding: "15px",
                        }}
                    >
                        <Button variant="contained" onClick={handleSave} color="primary">
                            Нэмэх
                        </Button>
                        <Button variant="contained" color="error" onClick={handleClose}>
                            хаах
                        </Button>
                    </Box>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default AddFlowerModal;
